import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useLibraryStore } from '../library.store'

/**
 * Composable for determining contributor visibility on library content cards
 * @param contentId - The UUID of the content to check contributor visibility for
 * @returns Object with computed properties for contributor visibility logic
 */
export function useContributorVisibility(contentId: string) {
  const libraryStore = useLibraryStore()
  const { getContributorIdsForContent, currentFolder } = storeToRefs(libraryStore)
  const contributorInfo = computed(() => getContributorIdsForContent.value?.[contentId])
  // Don't show contributor if they are the same as the folder owner
  const contributorIsNotOwner = computed(() => {
    if (!contributorInfo.value?.contributor || !currentFolder.value?.owner) {
      return !!contributorInfo.value?.contributor
    }
    return contributorInfo.value.contributor !== currentFolder.value.owner
  })
  const contributorIsVisible = computed(() => {
    return !!(contributorInfo.value && contributorInfo.value.contributor && contributorIsNotOwner.value)
  })

  return {
    contributorInfo,
    contributorIsVisible
  }
}
